import { ConsentBanner } from '../../features/analytics/ConsentBanner';
import { Outlet } from 'react-router-dom';

import { Header } from './Header';
import { Footer } from './Footer';
import { WhatsAppFab } from './WhatsAppFab';
import { CartDrawer } from '../../features/cart/CartDrawer';
import { Toaster } from '../ui/Toaster';
import { VerifyEmailBanner } from '../../features/auth/VerifyEmailBanner';

/** App shell: sticky header, routed page, footer, WhatsApp FAB, cart drawer, and toasts. */
export function Layout(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <VerifyEmailBanner />
      <main id="main" tabIndex={-1} className="flex-1 scroll-mt-36 outline-none">
        <Outlet />
      </main>
      <aside aria-label="Customer support" className="flex justify-center">
        <WhatsAppFab />
      </aside>
      <Footer />
      <CartDrawer />
      <Toaster />
      <ConsentBanner />
    </div>
  );
}
